var _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaitrise(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Groupe_2890",
    "data-name": "Groupe 2890",
    width: 85.298,
    height: 85.298,
    viewBox: "0 0 85.298 85.298",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_90",
    "data-name": "Ellipse 90",
    cx: 42.649,
    cy: 42.649,
    r: 42.649,
    fill: "#f9c977"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2456",
    "data-name": "Groupe 2456",
    transform: "translate(22.642 19.091)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2457",
    "data-name": "Groupe 2457",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2458",
    "data-name": "Groupe 2458"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_822",
    "data-name": "Trac\\xE9 822",
    d: "M20.775-.444a1,1,0,0,1,.468.116,56.373,56.373,0,0,0,6,2.625A36.16,36.16,0,0,0,39.317,4.892c.327,0,.651-.009.963-.025a1,1,0,0,1,1.052.942,120.515,120.515,0,0,1-.047,14.048c-.5,7.494-1.784,13.076-3.81,16.592a59.636,59.636,0,0,1-8,10.861,27.053,27.053,0,0,1-8.408,6.512,1,1,0,0,1-.924-.076c-.361-.228-.728-.456-1.083-.676C14.852,50.457,10.5,47.755,4.258,36.817A33.685,33.685,0,0,1,.767,27.012,63.478,63.478,0,0,1-.424,16.91,79.6,79.6,0,0,1-.151,5.754,1,1,0,0,1,.924,4.868h0s.15.011.439.011c1.709,0,8.13-.378,19-5.236A1,1,0,0,1,20.775-.444ZM39.317,6.892a37.622,37.622,0,0,1-12.8-2.731,60.259,60.259,0,0,1-5.775-2.5A69.588,69.588,0,0,1,7.828,6.043a32.6,32.6,0,0,1-6.075.831,82.531,82.531,0,0,0-.178,9.981,61.409,61.409,0,0,0,1.154,9.767A31.7,31.7,0,0,0,6,35.827a50.135,50.135,0,0,0,7.791,10.781,32.07,32.07,0,0,0,6.331,4.763l.64.4a27.057,27.057,0,0,0,7.262-5.827A58.437,58.437,0,0,0,35.742,35.45,24.3,24.3,0,0,0,38.176,28.4a64.056,64.056,0,0,0,1.113-8.676,117.937,117.937,0,0,0,.1-12.831Z",
    transform: "translate(-0.5 -0.556)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_823",
    "data-name": "Trac\\xE9 823",
    d: "M30.587,7.409a1,1,0,0,1,.371.071c.1.039,9.868,3.924,14.687,3.924a1,1,0,0,1,1,1c0,.405.014.914.03,1.5a64.6,64.6,0,0,1-.21,8.495A40.947,40.947,0,0,1,43.65,33.991a37.893,37.893,0,0,1-7.685,11.331,40.455,40.455,0,0,1-4.789,4.307,1,1,0,0,1-1.589-.808V8.409a1,1,0,0,1,1-1ZM44.66,13.363c-4.167-.322-10.343-2.48-13.073-3.5V46.722c.8-.691,1.841-1.644,2.967-2.817A35.859,35.859,0,0,0,41.8,33.227C45,25.5,44.788,17.995,44.676,13.962Q44.668,13.648,44.66,13.363Z",
    transform: "translate(-9.762 -2.684)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Ligne_15",
    "data-name": "Ligne 15",
    d: "M28.433,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H28.433a1,1,0,0,1,1,1A1,1,0,0,1,28.433,1Z",
    transform: "translate(5.436 24.269)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaitrise);
export default __webpack_public_path__ + "static/media/maitrise.3914b81933ec7a5e5e916f42af3bfd0b.svg";
export { ForwardRef as ReactComponent };